import styled from "styled-components"

export const Global = styled.div`
    font-family:"Montserrat";
`